import React from 'react';
import { createSelector } from '@reduxjs/toolkit';

import type { IResourceDatabaseRecord } from '@/api/types';
import type { RootState } from '@/store';
import type { ISelectedFolder } from '@/store/types';

import { useAppSelector, useResourceNavigation } from '@/hooks';
import { combineSelectedView } from '@/store/combiners/resourcesCombiners';
import { selectFoldersList } from '@/store/selectors/resourcesSelectors';
import { DatabaseViewItemPreview } from '.';

const databaseResourcePreviewSelector = createSelector(
  selectFoldersList,
  (_: RootState, selectedFolder: ISelectedFolder) => selectedFolder,
  (foldersList, selectedFolder) => ({
    fields: [...(combineSelectedView(foldersList, selectedFolder)?.props || [])].sort(
      (colA, colB) => colA.position - colB.position,
    ),
  }),
);

interface IDatabaseResourcePreviewBodyProps {
  resource: IResourceDatabaseRecord;
}

const DatabaseResourcePreviewBody = ({ resource }: IDatabaseResourcePreviewBodyProps): React.ReactElement => {
  const { selectedFolder } = useResourceNavigation();
  const { fields } = useAppSelector(state => databaseResourcePreviewSelector(state, selectedFolder));

  return <DatabaseViewItemPreview resource={resource as IResourceDatabaseRecord} databaseFields={fields} />;
};

export { DatabaseResourcePreviewBody };
